<template>
    <div class="steps bg-darkest lightest text-center px-5" style="margin: 0px 32px">
        <ul class="d-flex align-items-center justify-content-center">
            <li
                class="d-flex align-items-center lightest p-3 m-2"
                v-for="step in steps"
                @click="switchStep(step)"
                :class="{ active: (step.number === currentStep) }">
                    <span class="number radius-circle">{{ step.number }}</span>
                    <span>{{ step.label }}</span>
            </li>
        </ul>
    </div>

</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: {
            currentStep: Number,
            steps: Array,
            allowClickToSwitchSteps: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            switchStep: function(step) {
                if (!this.allowClickToSwitchSteps) {
                    return;
                }

                this.$emit('switchStep', step.number);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .steps {
        height: 4.5rem;
    }
</style>



// WEBPACK FOOTER //
// integrationsSteps.vue?943664a0